import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LearnerLayout } from "./components/LearnerLayout";
import { AdminLayout } from "./components/AdminLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyCertificate from "./pages/VerifyCertificate";

import Dashboard from "./pages/Dashboard";
import Learning from "./pages/Learning";
import PathDetail from "./pages/PathDetail";
import ModuleView from "./pages/ModuleView";
import Quiz from "./pages/Quiz";
import CTF from "./pages/CTF";
import CTFDetail from "./pages/CTFDetail";
import Leaderboard from "./pages/Leaderboard";
import Certificates from "./pages/Certificates";
import Announcements from "./pages/Announcements";
import Profile from "./pages/Profile";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminPaths from "./pages/admin/AdminPaths";
import AdminPathEditor from "./pages/admin/AdminPathEditor";
import AdminCTF from "./pages/admin/AdminCTF";
import AdminCertificates from "./pages/admin/AdminCertificates";
import AdminAnnouncements from "./pages/admin/AdminAnnouncements";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminConfig from "./pages/admin/AdminConfig";

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#121C30", border: "1px solid rgba(255,255,255,0.08)", color: "#fff" } }} richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify/:vid" element={<VerifyCertificate />} />

          <Route path="/app" element={<ProtectedRoute><LearnerLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="learning" element={<Learning />} />
            <Route path="learning/:pathId" element={<PathDetail />} />
            <Route path="modules/:moduleId" element={<ModuleView />} />
            <Route path="quiz/:quizId" element={<Quiz />} />
            <Route path="ctf" element={<CTF />} />
            <Route path="ctf/:cid" element={<CTFDetail />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="certificates" element={<Certificates />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="profile" element={<Profile />} />
          </Route>

          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="paths" element={<AdminPaths />} />
            <Route path="paths/:pathId" element={<AdminPathEditor />} />
            <Route path="ctf" element={<AdminCTF />} />
            <Route path="certificates" element={<AdminCertificates />} />
            <Route path="announcements" element={<AdminAnnouncements />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="config" element={<AdminConfig />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
